jQuery(document).ready(function(){
  jQuery('.review_slider_list').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    autoplay: true,
    autoplaySpeed: 3000,    
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
        fade: true,
  		cssEase: 'linear'
      }
    }
  ]
  });
  jQuery(document).ready(function(){
   jQuery(".header-style-4 .awemenu-mobile .awemenu-bars .fa-bars ").click(function() {
      jQuery(".bottom_bar").toggleClass('bottomHide');
   });
  });
//   jQuery('.slider_gallery .slider').owlCarousel({
//     stagePadding: 50,
//     loop:true,
//     margin:30,
//     nav:true,
//     center: true,
//     responsive:{
//       767:{
//         items:3
//       },
//       1025:{
//         items:4
//       },
//       1401:{
//         items:5
//       }
//     }
//   });
//   var owl = $('.slider_gallery .slider');
//   owl.owlCarousel();
//   // Go to the next item
//   $('.slider_gallery .arrows .arrow-right').click(function() {
//     owl.trigger('next.owl.carousel');
//   });
//   // Go to the previous item
//   $('.slider_gallery .arrows .arrow-left').click(function() {
//     owl.trigger('prev.owl.carousel', [300]);
//   });
  
  jQuery('.slider_gallery .slider').slick({
    infinite: true,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 5,
    arrows:true,
    dots:true,  
    prevArrow: jQuery(".slider_gallery .arrow-left"),
    nextArrow: jQuery(".slider_gallery .arrow-right"),
    responsive: [
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 5,
         centerPadding: '20px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1680,
      settings: {
        slidesToShow: 5,
        centerPadding: '0px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
        centerPadding: '300px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 3,
        centerPadding: '240px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 3,
        centerPadding: '180px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        centerPadding: '120px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerPadding: '200px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        centerPadding: '120px',
    	slidesToScroll: 1,
      }
    },
    {
      breakpoint: 440,
      settings: {
        slidesToShow: 1,
        centerPadding: '80px',
    	slidesToScroll: 1,
      }
    }
  ]
  });
  
  jQuery(window).scroll(function() {
	if (jQuery(this).scrollTop() > 50) {
        jQuery('.header-style-4').addClass('et-fixed-header');
    }else{
      jQuery('.header-style-4').removeClass('et-fixed-header');
    }
  });
  
  <!-- show bar bottom-->
  jQuery(".backtop").click(function() {
      jQuery("html, body").animate({scrollTop: 0}, 1000);
   });
  jQuery(window).scroll(function() {
      if (jQuery(this).scrollTop() > 200) {
          jQuery('.bottom_bar').addClass('show');
      }
      if(jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() - 100) {
         jQuery('.bottom_bar').addClass('bottom');
      }else{
         jQuery('.bottom_bar').removeClass('bottom'); 
      }
  });
  jQuery('.bottom_bar .left').on('click',function(){
      if(jQuery(this).hasClass('open')){
          jQuery(this).removeClass('open');
          jQuery(this).parent().removeClass('active');
      }else{
          jQuery(this).addClass('open');
          jQuery(this).parent().addClass('active');
      }
  });
  
  jQuery('.icon_bar').on('click',function(){
    if(jQuery(this).hasClass('open')){
      jQuery(this).removeClass('open');
      jQuery(this).parents('.awemenu-container').removeClass('show');
    }else{
      jQuery(this).addClass('open');
      jQuery(this).parents('.awemenu-container').addClass('show');
    }
  });
  jQuery('.mobile_nav_menu .close').on('click',function(){
    jQuery('.icon_bar').removeClass('open');
    jQuery('.awemenu-container').removeClass('show');
  });
});